export function getBoxInObjectSpace(object, objectSpace) {
  const THREE = window.THREE;
  const box = new THREE.Box3().setFromObject(object);
  const objectWorldInverse = new THREE.Matrix4().copy(objectSpace.matrixWorld).invert();
  box.applyMatrix4(objectWorldInverse);
  return box;
}

export function setVertexFromObjectLocal(mesh, objectSpace, vertex, objectLocalVertex) {
  objectSpace.localToWorld(objectLocalVertex);
  mesh.worldToLocal(objectLocalVertex);
  vertex.copy(objectLocalVertex);
}

export function recomputeGeometryBounds(geometry) {
  geometry.computeVertexNormals();
  geometry.computeBoundingBox();
  geometry.computeBoundingSphere();
}
